export default function LandingPage() {
    return (<div></div>)
}
